import { useState } from 'react';
import { DeleteAccountSubmit } from '../../../features/CommonSlice';

const DeleteAccount = () => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        delete_acc_email: '',
        phone: '',
        delete_reason: ''
    });

    const [errors, setErrors] = useState({});

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: value
    //     }));
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // For all fields except email, remove error as user types
        if (name !== 'delete_acc_email') {
            setErrors(prevErrors => ({
                ...prevErrors,
                [name]: ''
            }));
        }

        // For email, only remove error if the format is valid
        if (name === 'delete_acc_email') {
            const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
            if (isValidEmail) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    delete_acc_email: ''
                }));
            }
        }
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.first_name.trim()) newErrors.first_name = 'First name is required';
        if (!formData.last_name.trim()) newErrors.last_name = 'Last name is required';
        if (!formData.delete_acc_email.trim()) {
            newErrors.delete_acc_email = 'Email is required';
        } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.delete_acc_email)) {
            newErrors.delete_acc_email = 'Enter a valid email address';
        }
        if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
        if (!formData.delete_reason.trim()) newErrors.delete_reason = 'Message is required';

        return newErrors;
    };

    const handleSubmit = () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const dataToSubmit = { ...formData };
        if (!dataToSubmit.phone) {
            delete dataToSubmit.phone;
        }

        DeleteAccountSubmit(dataToSubmit, (response) => {
            if (response?.status === true) {
                setFormData({
                    first_name: '',
                    last_name: '',
                    delete_acc_email: '',
                    phone: '',
                    delete_reason: ''
                });
                setErrors({});
            }
        })();
    };

    return (
        <>
            <section className='cms_landing_page'>
                <div className='banner'>
                    Delete Account
                </div>
            </section>

            <section className='ptb-100'>
                <div className='container'>
                    <div className='contact_form'>
                        <form>
                            <div className='row g-4'>
                                <div className='col-md-6'>
                                    <label className='common_label'> <span className='required_star'>*</span>First Name</label>
                                    <input
                                        type="text"
                                        name="first_name"
                                        className='common_input'
                                        placeholder='First Name'
                                        value={formData.first_name}
                                        onChange={handleChange}
                                    />
                                    {errors.first_name && <div className="error">{errors.first_name}</div>}
                                </div>

                                <div className='col-md-6'>
                                    <label className='common_label'><span className='required_star'>*</span>Last Name</label>
                                    <input
                                        type="text"
                                        name="last_name"
                                        className='common_input'
                                        placeholder='Last Name'
                                        value={formData.last_name}
                                        onChange={handleChange}
                                    />
                                    {errors.last_name && <div className="error">{errors.last_name}</div>}
                                </div>

                                <div className='col-md-6'>
                                    <label className='common_label'><span className='required_star'>*</span>Email</label>
                                    <input
                                        type="email"
                                        name="delete_acc_email"
                                        className='common_input'
                                        placeholder='Email'
                                        value={formData.delete_acc_email}
                                        onChange={handleChange}
                                    />
                                    {errors.delete_acc_email && <div className="error">{errors.delete_acc_email}</div>}
                                </div>

                                <div className='col-md-6'>
                                    <label className='common_label'><span className='required_star'>*</span>Phone number</label>
                                    <input
                                        type="text"
                                        name="phone"
                                        className='common_input'
                                        placeholder='Phone Number'
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                    {errors.phone && <div className="error">{errors.phone}</div>}
                                </div>

                                <div className='col-md-12'>
                                    <label className='common_label'><span className='required_star'>*</span>Message</label>
                                    <textarea
                                        className='common_input text_area'
                                        name="delete_reason"
                                        rows="10"
                                        placeholder='Message'
                                        value={formData.delete_reason}
                                        onChange={handleChange}
                                    />
                                    {errors.delete_reason && <div className="error">{errors.delete_reason}</div>}
                                </div>

                                <div className='col-md-12'>
                                    <button type="button" className="themeBtn2_2" onClick={handleSubmit}>
                                        SUBMIT
                                        <img src="/images/website/theme_2_arrow.svg" alt="aero" />
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DeleteAccount;
